export default "/images/cd1b308848f64fb3a2a2280aee0e4d9f.avif";